import { LinearProgress, Typography } from '@mui/material';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { MdAdd } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';

import ToasterBox from '../../../components/singleComponents/toaster/ToasterBox';
import { useFile } from '../../../../hooks/file';
import api, { authHeader } from '../../../../services/API/apiConfig';
import { Header } from '../../../components/singleComponents/headers';
import { TablePayables } from '../../../components/singleComponents/tables/TablePayables';
import ProgressBox from '../../../components/singleComponents/tutorial/ProgressBox';
import ProgressDrawer from '../../../components/singleComponents/tutorial/ProgressDrawer';

import { TourContext } from '../../../../context/tour';

import 'driver.js/dist/driver.css';
import './driverjs.css';
import {
  DragFilesStyled,
  LoadingStyled,
  ReleasesStyled,
  RootStyled,
} from './homeAdmin.styles';

const headings = [
  'Vencimento',
  'Fornecedor',
  'Descrição',
  'Obra',
  'Item',
  'Valor',
  'Status',
  'Lançamento',
  'Anexos',
  'Duplicar',
];

export default function HomeAdmin() {
  const navigate = useNavigate();
  const location = useLocation();

  const { isProgressOpen } = useContext(TourContext);

  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');
  const [filterData, setFilterData] = useState([]);

  const { getRootProps, getInputProps, acceptedFiles, isDragActive } =
    useDropzone({
      accept: 'application/pdf',
      multiple: false,
    });

  const { setFile } = useFile();

  const goToEditPayable = (id) => {
    navigate(`/new-release/${id}`, { state: { from: '/admin' } });
  };

  const handleGoToNewRelease = () => {
    setFile('');
    navigate('/new-release', { state: { from: location.pathname } });
  };

  const sendFile = useCallback(
    async (formData) => {
      try {
        setLoading(true);
        const response = await api.post('/payables/ocr', formData, {
          headers: {
            ...authHeader(),
            'Content-Type': 'multipart/form-data',
          },
        });

        const { data } = response.data;
        if (data) {
          window.localStorage.setItem('ticket', JSON.stringify(data));
          setLoading(false);
          navigate('/new-release');
        }
      } catch (error) {
        setErrorMsg(error.response.data.messages);
        setLoading(false);
      } finally {
        setTimeout(() => setErrorMsg(''), 3000);
      }
    },
    [navigate]
  );

  useEffect(() => {
    if (acceptedFiles.length) {
      if (acceptedFiles[0].type !== 'application/pdf') {
        setErrorMsg(
          'Arquivo inválido. Por favor, selecione um arquivo do tipo ".pdf".'
        );
      } else {
        const fd = new FormData();
        fd.append('file', acceptedFiles[0]);
        setFile(acceptedFiles[0]);
        sendFile(fd);
      }
    }
  }, [acceptedFiles, sendFile, setFile]);

  return (
    <>
      {errorMsg && <ToasterBox message={errorMsg} />}
      <Header page="Home" />
      <ProgressDrawer />
      {isProgressOpen && <ProgressBox />}
      <RootStyled>
        {loading ? (
          <LoadingStyled>
            <LinearProgress style={{ width: '80%' }} />
          </LoadingStyled>
        ) : (
          <>
            <ReleasesStyled>
              <div id="payable-dropdown" className="ticket" {...getRootProps()}>
                <input {...getInputProps()} multiple={false} />
                <Typography style={{ fontSize: '14px' }}>
                  {isDragActive ? 'Solte aqui' : 'Arraste o boleto'}
                </Typography>
              </div>
              OU
              <DragFilesStyled
                variant="contained"
                color="secondary"
                onClick={handleGoToNewRelease}
                id="payables"
              >
                <MdAdd size={21} />
                Novo lançamento
              </DragFilesStyled>
            </ReleasesStyled>
            <TablePayables
              filter={filter}
              setFilter={setFilter}
              headings={headings}
              constructionId={null}
              callbackClickRow={goToEditPayable}
              isConstruction={false}
              setLoading={setLoading}
              filterData={filterData}
              setFilterData={setFilterData}
            />
          </>
        )}
      </RootStyled>
    </>
  );
}
